import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './utils/console';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
// Temporarily disable service worker to fix API issues
// import { registerServiceWorker } from './serviceWorker';
// registerServiceWorker();
